import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REFRESH_TOKEN } from "../../../config/api";
import { Client } from "../../../client";
import { Cookies } from "react-cookie";

export const getNewToken = createAsyncThunk(
  "opportunities/getNewToken",
  async () => {
    try {
      const { data } = await Client({
        method: "POST",

        path: API_REFRESH_TOKEN,
        noRefreshToken: true,
      });
      const token = data?.data?.access_token;
      if (token) {
        const cookies = new Cookies();
        const nextDate = new Date().setMinutes(new Date().getMinutes() + 20);
        cookies.set("accessToken", token, {
          expires: new Date(nextDate),
        });
      }
      return data?.data?.access_token;
    } catch (error) {}
  }
);
